import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "benefit-row" }
const _hoisted_2 = { class: "my-table-row" }
const _hoisted_3 = { class: "the-col" }
const _hoisted_4 = { class: "the-label" }
const _hoisted_5 = { class: "the-value" }
const _hoisted_6 = {
  key: 0,
  class: "the-col"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Tier", -1)
const _hoisted_8 = { class: "the-value" }
const _hoisted_9 = { class: "the-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Monthly Premium", -1)
const _hoisted_11 = { class: "the-value the-number" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Effective Date Of Coverage", -1)
const _hoisted_14 = { class: "the-value the-number" }
const _hoisted_15 = {
  key: 0,
  class: "bundle-benefit-container"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Benefits", -1)
const _hoisted_17 = {
  key: 1,
  class: "coverage-title"
}
const _hoisted_18 = { class: "my-table-row dep-rows" }
const _hoisted_19 = { class: "dep-name" }
const _hoisted_20 = { class: "dep-relation" }
const _hoisted_21 = {
  key: 2,
  class: "subsidy-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.bundle ? "Bundle" : "Benefit"), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.bundle ? _ctx.bundle.bundleName : _ctx.unbundledBenefit.planDescription), 1)
      ]),
      (
          (_ctx.unbundledBenefit &&
            _ctx.unbundledBenefit.benefitRateTypeId === _ctx.common.benefit.tier) ||
          (_ctx.bundle && _ctx.bundle.benefitRateTypeId === _ctx.common.benefit.tier)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.tierName(_ctx.unbundledBenefit, _ctx.bundle)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createTextVNode(" $" + _toDisplayString(_ctx.monthlyPrice(_ctx.unbundledBenefit, _ctx.bundle)) + "/Month ", 1),
          (_ctx.subsidyMessage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["the-col", {
          'flex-2':
            (_ctx.unbundledBenefit &&
              _ctx.unbundledBenefit.benefitRateTypeId !== _ctx.common.benefit.tier) ||
            (_ctx.bundle && _ctx.bundle.benefitRateTypeId !== _ctx.common.benefit.tier),
        }])
      }, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatEffectiveDate(_ctx.effectiveDate!)), 1)
      ], 2)
    ]),
    (_ctx.bundle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bundle.benefits, (data, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              class: "the-value"
            }, _toDisplayString(data.planDescription), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.getDependentInformation(_ctx.unbundledBenefit, _ctx.bundle).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Coverage "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDependentInformation(_ctx.unbundledBenefit, _ctx.bundle), (data, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "the-col",
          key: key
        }, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(data.firstName + " " + data.lastName), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(data.relationshipName), 1)
        ]))
      }), 128))
    ]),
    (_ctx.subsidyMessage)
      ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.subsidyMessage), 1))
      : _createCommentVNode("", true)
  ]))
}